__turbopack_context__.v({
  "brand": "_3Fd-jW_brand",
  "brand--center": "_3Fd-jW_brand--center",
  "brand--start": "_3Fd-jW_brand--start",
  "partner": "_3Fd-jW_partner",
  "partner-logo": "_3Fd-jW_partner-logo",
  "separator": "_3Fd-jW_separator",
  "wordmark": "_3Fd-jW_wordmark",
  "wordmark--sacramento": "_3Fd-jW_wordmark--sacramento",
});
